var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#fff",
      fillOpacity: 1
    },
    d: "M21.441 20.883H2.531a2.399 2.399 0 0 1-2.398-2.399V5.488A2.401 2.401 0 0 1 2.53 3.09h18.91a2.401 2.401 0 0 1 2.399 2.398v12.996a2.399 2.399 0 0 1-2.399 2.399zM2.531 4.672a.82.82 0 0 0-.82.816v12.996c0 .45.367.82.82.82h18.91c.454 0 .82-.37.82-.82V5.488a.82.82 0 0 0-.82-.816zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#fff",
      fillOpacity: 1
    },
    d: "M11.988 14.734a5.1 5.1 0 0 1-3.754-1.656L.79 4.906l1.168-1.062 7.445 8.168a3.467 3.467 0 0 0 2.586 1.14c.992 0 1.91-.406 2.582-1.14l7.446-8.168 1.168 1.062-7.446 8.172a5.097 5.097 0 0 1-3.75 1.656zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#fff",
      fillOpacity: 1
    },
    d: "m.832 19.063 7.242-7.282 1.121 1.117-7.242 7.278zM14.781 12.898l1.117-1.117 7.247 7.281-1.122 1.118zm0 0"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.1dd54906bf18f351f6133520e91b064a.svg";
export { ForwardRef as ReactComponent };